import axios from "axios";

/**
 * Fetches the meeting associated to a unique identifier
 * @param {string} urlId The unique identifier associated to the chime meeting
 * @returns The associated chime meeting details
 */
export const fetchMeeting = async (urlId) => {
    try {
        const response = await axios.get(
            `${process.env.REACT_APP_BASE_URL_REST_API_ASSISTANCE}/companion/meet-details/?url_id=${urlId}`
        );

        return response;
    } catch (error) {
        console.error(error);
    }
}
